import { GET_RESULTS } from '../action-types';
import { START_SEARCH } from '../../form/action-types';
import { getIsFetching, getRequestStatus } from '../../../requests/selectors';

// Selectors
export const [isFetchingSelector, hasErrorSelector, errorDataSelector] = getRequestStatus(GET_RESULTS);
export const isSearchRequestPendingSelector = (state) => getIsFetching(state, START_SEARCH);
export const isSearchingSelector = (state) => state.search.results.isSearching;
export const isWaitingSelector = (state) => state.search.results.isWaiting;
